// extracted by mini-css-extract-plugin
module.exports = {"toggle":"ThemeToggle_toggle__RoeI1"};